"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LarixInstruction = exports.LarixInstructionCollector = void 0;
const index_1 = require("./index");
class LarixInstructionCollector {
    constructor(wallet, transactions) {
        this.wallet = wallet;
        this.transactionResults = [];
        if (transactions) {
            this.larixInstructions = transactions;
        }
        else {
            this.larixInstructions = new Array();
        }
        this.newTransaction();
    }
    add(transactionElement) {
        this.larixInstructions.push(transactionElement);
    }
    newTransaction() {
        this.larixInstructions.push(new LarixInstruction(this.wallet));
    }
    get signers() {
        return this.lastTransaction.signers;
    }
    get cleanupInstructions() {
        return this.lastTransaction.cleanupInstructions;
    }
    get instructions() {
        return this.lastTransaction.instructions;
    }
    addInstruction(instruction) {
        this.lastTransaction.instructions.push(instruction);
    }
    addCleanupInstruction(instruction) {
        this.lastTransaction.cleanupInstructions.push(instruction);
    }
    addSigner(signer) {
        this.lastTransaction.signers.push(signer);
    }
    get lastTransaction() {
        return this.larixInstructions[this.larixInstructions.length - 1];
    }
    send() {
        return __awaiter(this, void 0, void 0, function* () {
            let user = this.wallet.publicKey;
            let currentTransaction;
            for (let i = 0; i < this.larixInstructions.length; i++) {
                if (!currentTransaction) {
                    currentTransaction = this.larixInstructions[i];
                }
                else {
                    currentTransaction.mergeTransaction(this.larixInstructions[i]);
                }
                let transactionResult;
                if (i == this.larixInstructions.length - 1) {
                    transactionResult = yield currentTransaction.send(); // end of loop
                }
                else if (currentTransaction.isReachTransactionLimit(this.larixInstructions[i + 1], user)) {
                    transactionResult = yield currentTransaction.send();
                    currentTransaction = undefined;
                }
                if (transactionResult) {
                    transactionResult.instruction = currentTransaction;
                    this.transactionResults.push(transactionResult);
                    if (transactionResult.result && transactionResult.result.value.err) {
                        throw new Error("Transaction err");
                    }
                }
            }
            return this.transactionResults;
        });
    }
}
exports.LarixInstructionCollector = LarixInstructionCollector;
class LarixInstruction {
    constructor(wallet, instructions, cleanupInstructions, signers) {
        this.wallet = wallet;
        if (instructions) {
            this.instruction = instructions;
        }
        else {
            this.instruction = new Array();
        }
        if (cleanupInstructions) {
            this.cleanupInstruction = cleanupInstructions;
        }
        else {
            this.cleanupInstruction = new Array();
        }
        if (signers) {
            this.signers = signers;
        }
        else {
            this.signers = new Array();
        }
    }
    get instructions() {
        return this.instruction;
    }
    get allInstructions() {
        return this.instruction.concat(this.cleanupInstruction);
    }
    get cleanupInstructions() {
        return this.cleanupInstruction;
    }
    addInstruction(instruction) {
        this.instruction.push(instruction);
    }
    addCleanupInstruction(instruction) {
        this.cleanupInstruction.push(instruction);
    }
    addSigner(signer) {
        this.signers.push(signer);
    }
    mergeTransaction(other) {
        this.instruction = this.instruction.concat(other.instruction);
        this.cleanupInstruction = this.cleanupInstruction.concat(other.cleanupInstruction);
        this.signers = this.signers.concat(other.signers);
    }
    isReachTransactionLimit(other, user) {
        return (0, index_1.isReachTransactionLimit)(this.wallet.connection, user, this.allInstructions.concat(other.allInstructions), this.signers.concat(other.signers));
    }
    send() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.wallet.sendTransaction(this.allInstructions, this.signers);
        });
    }
}
exports.LarixInstruction = LarixInstruction;
